import { getTextColor } from "helper/getColor";
import { getNumberOfStars, getGradeId } from "utility";
import { setLocalStorage } from "../helper/localStorage";

let initState = {
  spinner: false,
  token: "amazewebtokentedf8i70ghsghrst",
  //host: 'http://testnew.empass.mobi/testamazeapi/index.php/',
  host: "https://apptest.mymemorymentor.com/testamazeapi/index.php/",
  apiEnd: {
    metaData: "MetaData",
    profile: "UserProfile",
    userTestData: "UserTestData",
  },
  apiTask: {
    getStudentList: "getstudentlist",
    getStundentTest: "studenttestlist",
    assignTest: "assigntest",
    gettestSummary: "gettestsummary",
    surveyList: "surveylist",
    testResponse: "gettestresponse",
    reportedQuesList: "reportedquelist",
    reportIssue: "reportissue",
    reviewTest: "reviewtest",
    reTest: "deletetestdata",
    verifyCode: "verifycode",
    login: "assessorlogin",
    getSurvey: "getsurveyque",
    submitSurvey: "addsurveyresult",
    feedbackQue: "getfeedbackque",
    submitFeedbck: "addfeedback",
    feedbackSummery: "getfeedbacksummary",
    logOut: "logout",
    getgcoordchartdata: "getgcoordchartdata",
    refreshdata: "refreshdata",
    setpublishstatus: "setpublishstatus",
    offlineprocessaudio: "offlineprocessaudio",
    getstudentflagnotes: "getstudentflagnotes",
    setstudentflagnotes: "setstudentflagnotes",
    flagqueitem: "flagqueitem",
    schoolcodelist: "schoolcodelist",
    reportedtestlist: "reportedtestlist",
    reportedplrlist: "reportedplrlist",
    testlistinfo: "testlistinfo",
    getplrwisesummary: "getplrwisesummary",
    getchartrpt1: "getchartrpt1",
    getchartrpt2: "getchartrpt2",
    getchartrpt3: "getchartrpt3",
    testgroupleaderboard: "testgroupleaderboard",
  },
  levels: {
    L1: 2,
    L2: 5,
    L3: 8,
    L4: 12,
  },
};
export const globaReducer = (state = initState, action) => {
  switch (action.type) {
    case "SHOW_SPPINER":
      return {
        ...state,
        spinner: true,
      };
    case "HIDE_SPPINER":
      return {
        ...state,
        spinner: false,
      };
    default:
      return state;
  }
};

export const surveyReducer = (state = [], action) => {
  switch (action.type) {
    case "FETCHING_SURVEY":
      return [];
    case "SET_SURVEY":
      return action.survey;
    default:
      return state;
  }
};

export const testReducer = (state = [], action) => {
  switch (action.type) {
    case "FETCHING_TEST":
      return [];
    case "SET_TEST":
      console.log("action.test", action.test);
      return action.test;
    default:
      return state;
  }
};

export const singleTestReducer = (
  state = {
    error: false,
    message: "Something went wrong",
    loading: true,
    data: [],
  },
  action
) => {
  switch (action.type) {
    case "RESET_TEST_RESPONSE":
      return {
        error: false,
        message: "Something went wrong",
        loading: true,
        data: {},
      };
    case "FETCHING_TEST_RESPONSE":
      return state;
    case "FETCHING_TEST_RESPONSE_ERROR":
      return {
        ...state,
        error: true,
        message: action.err ? action.err.msg : "Something went wrong",
        loading: false,
        data: {},
      };
    case "SET_TEST_RESPONSE":
      return {
        error: false,
        loading: false,
        data: action.test,
      };
    default:
      return state;
  }
};

export const profilePageReducer = (state = [], action) => {
  switch (action.type) {
    case "SET_PROFILE_PAGE_STUDENT":
      return [...action.student];
    case "RESET_PROFILE_PAGE_STUDENT":
      return [];
    default:
      return state;
  }
};

export const testSummeryReducer = (state = [], action) => {
  switch (action.type) {
    case "FETCHING_TEST_SUMMERY":
      return [];
    case "SET_TEST_SUMMERY":
      console.log("action.test", action.test);
      return action.test.map((test) => {
        return {
          ...test,
          grade_map: test.grade_map.split(".").join("-"),
          age_map: test.age_map.split(".").join("-"),
        };
      });
    case "SET_TEST_RESPONSE_ERROR":
      return action.data;
    default:
      return state;
  }
};

export const editModalReducer = (
  state = {
    show: false,
    reason: [
      "Correct answer",
      "Partially correct answer",
      "Incorrect answer",
      "Other",
    ],
    correct: "",
    userAnswer: "",
    qid: "",
  },
  action
) => {
  switch (action.type) {
    case "HIDE_EDIT_MODAL":
      return {
        ...state,
        correct: "",
        userAnswer: "",
        show: false,
      };
    case "SHOW_EDIT_MODAL":
      return {
        ...state,
        ...action,
        show: true,
        correct_text: action.correct_text,
        userAnswer: action.userAnswer,
        qid: action.qid,
      };
    default:
      return state;
  }
};

export const editReportedModalReducer = (
  state = {
    show: false,
    reason: "",
    correctAnswer: "",
    userAnswer: "",
    uid: "",
    reportedAnswer: "",
    reportedScore: "",
    comment: "",
    statusarr: ["Submited", "Approved", "Rejected"],
    reasonarr: [
      "Correct answer",
      "Partially correct answer",
      "Incorrect answer",
      "Other",
    ],
  },
  action
) => {
  switch (action.cases) {
    case "HIDE_REPORTED_EDIT_MODAL":
      return {
        ...state,
        // correctAnswer: "",
        // userAnswer: "",
        show: false,
      };
    case "SHOW_REPORTED_EDIT_MODAL":
      return {
        ...state,
        ...action,
        show: true,
        // correctAnswer: action.correctAnswer,
        // userAnswer: action.userAnswer,
        // uid: action.uid,
        // reportedAnswer: action.reportedAnswer,
        // reportedScore: action.reportedScore,
        // reason: action.reason,
        // comment: action.comment,
      };
    default:
      return state;
  }
};

const student = {
  all: [],
  new: [],
  filtered: [],
  student: {},
  columnfiltered: [],
  notFound: false,
  studentCount: [],
  bubbleData: [],
};

export const studentReducer = (state = student, action) => {
  switch (action.type) {
    case "SET_ALL_STUDENT":
      localStorage.setItem("std", JSON.stringify(action.student));
      console.log("studentList", action.student);
      return {
        ...state,
        all: action.student,
        columnfiltered: action.student,
      };
    case "SET_STUDENT_BY_ID":
      return {
        ...state,
        student: {
          ...action.std,
          grade_map: action.std && action.std.grade_map.split(".").join("-"),
          age_map: action.std && action.std.age_map.split(".").join("-"),
        },
      };
    case "SET_NEW_STUDENT":
      const allStudent = state.all.length ? state.all : [];
      // state.notFound = state.all.length ? false : true;
      const newStudent = allStudent.filter((std) => std.status == "UNASSIGNED");
      // if (action.index === "1") {
      //   console.log("ujjwal hello", newStudent);
      //   if (newStudent.length) {
      //     state.notFound = false;
      //   } else {
      //     state.notFound = true;
      //   }
      // }

      return {
        ...state,
        new: newStudent,
      };
    case "FILTER_STUDENT":
      const filtered = state.all.filter(
        (std) =>
          std.fullname.toLowerCase().indexOf(action.query.toLowerCase()) !== -1
      );
      return {
        ...state,
        filtered: filtered,
      };
    case "COLUMN_FILTER":
      console.log("column filter state", state);

      const reg_name = new RegExp(`^${action.query.name.toLowerCase()}`);
      const reg_status = new RegExp(`^${action.query.status.toLowerCase()}`);
      const reg_grade = new RegExp(`^${action.query.grade}`);
      const reg_age = new RegExp(`^${action.query.age}`);
      const reg_strength = new RegExp(`^${action.query.strength}`);
      const reg_weakness = new RegExp(`^${action.query.weakness}`);
      const reg_published = new RegExp(`^${action.query.published}`);
      const reg_level = new RegExp(`^${action.query.level}`);
      const columnfiltered = state.all.filter((std) => {
        const testdate = std.test_date === null ? "" : std.test_date;
        return (
          !!std.fullname.toLowerCase().match(reg_name) &&
          !!std.status.toLowerCase().match(reg_status) &&
          !!std.grade.match(reg_grade) &&
          !!std.age.match(reg_age) &&
          !!String(getNumberOfStars(std, getTextColor, "stars")).match(
            reg_strength
          ) &&
          !!String(getNumberOfStars(std, getTextColor, "flags")).match(
            reg_weakness
          ) &&
          !!std.is_published.toLowerCase().match(reg_published) &&
          // !!std.grade_id.match(reg_level) &&
          !!String(getGradeId(std.grade)).match(reg_level) &&
          testdate.indexOf(action.query.testDate) > -1
        );
      });
      console.log("testing", columnfiltered);
      if (columnfiltered.length === 0) {
        return {
          ...state,
          filtered: columnfiltered,
          notFound: true,
        };
      }
      return {
        ...state,
        filtered: columnfiltered,
        columnfiltered,
        notFound: false,
      };
    case "RESET_FILTER":
      return {
        ...state,
        // filtered: [],
        // // student: {},
        // notFound: false,
        all: [],
        new: [],
        filtered: [],
        student: {},
        columnfiltered: [],
        notFound: false,
        studentCount: [],
        bubbleData: [],
      };

    case "HOME_PAGE_BUBBLES":
      return {
        ...state,
        bubbleData: action.count,
      };

    default:
      return state;
  }
};

const params = { currentParams: {} };

export const paramReducer = (state = params, action) => {
  switch (action.type) {
    case "SET_PARAMS": {
      setLocalStorage("params", action.payload);
      return { currentParams: action.payload };
    }
    default: {
      return state;
    }
  }
};

export const messageReducer = (
  state = { msg: null, status: "", msgFrom: "" },
  action
) => {
  switch (action.type) {
    case "SET_MSG":
      return {
        msg: action.msg.msg,
        status: action.msg.status,
        msgFrom: action.msg.msgFrom,
      };

    case "RESET_MSG":
      return { msg: null, status: "", msgFrom: "" };

    default:
      return state;
  }
};

export const filterStateReducer = (
  state = {
    home: { filterBy: { level: "" }, orderBy: "asc", sortBy: "" },
    testList: { filterBy: "", orderBy: "asc", sortBy: "" },
    testTab: { filterBy: "", orderBy: "asc", sortBy: "actionTag" },
    testStudentList: {
      filterBy: { grade: "", proficiency: "", level: "" },
      orderBy: "dsc",
      sortBy: "",
    },
  },
  action
) => {
  switch (action.type) {
    case "SET_FILTER_STATE":
      console.log("actionaction", action);
      return {
        ...state,
        [action.pageName]: {
          ...state[action.pageName],
          filterBy: action.filterBy,
          orderBy: action.orderBy,
          sortBy: action.sortBy,
        },
      };

    default:
      return state;
  }
};

export const radarChartReducer = (state = { score: [] }, action) => {
  switch (action.type) {
    case "SET_RADAR_CHART":
      console.log("actionaction", action);
      return {
        score: action.score,
      };
    default:
      return state;
  }
};

const publishStudent = {
  student: [],
  all: [],
  isPublished: "",
  columnfiltered: [],
  notFound: false,
};

export const publishStudentReducer = (state = publishStudent, action) => {
  switch (action.type) {
    case "SET_ALL_PUBLISH_STUDENT":
      localStorage.setItem("std", JSON.stringify(action.student));
      console.log("studentList", action.student);
      return {
        ...state,
        all: action.student,
        columnfiltered: action.student,
        notFound: false,
      };

    case "PUBLISH_COLUMN_FILTER":
      console.log("column filter state", state, action);
      const reg_name = new RegExp(`^${action.query?.name.toLowerCase()}`);

      const reg_level = new RegExp(`^${action.query?.level}`);
      const columnfiltered = state.all?.filter((std) => {
        const testDate = std.test_date === null ? "" : std.test_date;

        return (
          !!std.fullname.toLowerCase().match(reg_name) &&
          !!String(getGradeId(std.grade)).match(reg_level) &&
          testDate.indexOf(action.query.date) > -1
        );
      });
      console.log("testing", columnfiltered);
      if (columnfiltered?.length === 0) {
        return {
          ...state,
          columnfiltered: columnfiltered,
          notFound: true,
        };
      }
      return {
        ...state,
        columnfiltered: columnfiltered,
        notFound: false,
      };
    case "SET_PUBLISH_TOGGLE":
      return {
        ...state,
        isPublished: "NO ERROR",
      };
    case "RESET_PUBLISH_TOGGLE":
      return {
        ...state,
        isPublished: "ERROR",
      };

    default:
      return state;
  }
};

export const offlineSyncReducer = (
  state = { allTest: [], isUploaded: "" },
  action
) => {
  switch (action.type) {
    case "GET_ALL_OFFLINE_SYNC_TEST":
      return {
        ...state,
        allTest: action.response,
        isUploaded: false,
      };
    case "DATA_SYNCED_OFFLINE":
      return state;
    default:
      return { ...state, isUploaded: true };
  }
};

export const flagNotesReducer = (state = { all: [] }, action) => {
  switch (action.type) {
    case "SET_ALL_FLAG_NOTES":
      return {
        ...state,
        all: action.data,
      };
    default:
      return state;
  }
};

export const refreshApiReducer = (state = { isActive: false }, action) => {
  switch (action.type) {
    case "SET_HOME_BUBBLE":
      return {
        ...state,
        isActive: action.data,
      };

    default:
      return state;
  }
};
